<template>
    <div>
        <div class="column is-paddingless is-marginless is-hidden-mobile"
             :class="[{'margin-left-20': addMarginLeft}]">
            <div class="columns">
                <div class="column is-paddingless is-marginless"
                     :class="desktopCss">
                    <input class="input is-size-6 input-search" @input="resetForm()" v-model.trim="keyword"
                           @keyup.enter="searchForm()" @keyup="keywordChanged" type="text" :placeholder="placeholder" @keypress="handleInput($event)">
                </div>
                <div class="column is-paddingless is-marginless is-narrow">
                    <button data-track="search" class="button-search"
                            @click.prevent="searchForm()">
                        <span class="icon">
                            <i class="fas fa-search"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-paddingless is-marginless is-fullwidth is-hidden-desktop is-hidden-tablet">
            <div class="columns is-mobile">
                <div class="column is-paddingless is-marginless"
                     :class="fieldCssMobile">
                    <input class="input is-size-6 input-search" @input="resetForm()" v-model.trim="keyword"
                           @keyup.enter="searchForm()" type="text"
                           @keyup="keywordChanged()" :placeholder="placeholder" @keypress="handleInput($event)">
                </div>
                <div class="column is-paddingless is-marginless"
                     :class="iconCssMobile">
                    <button data-track="search" class="button-search is-fullwidth"
                            @click.prevent="searchForm()">
                        <span class="icon">
                            <i class="fas fa-search"></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  export default {
    name: 'search',
    props: {
      placeholder: {
        type: String,
        default: 'Keyword Search'
      },
      addMarginLeft: {
        type: Boolean,
        default: true
      },
      desktopCss: {
        type: String,
        default: 'is-11-tablet is-5-desktop'
      },
      fieldCssMobile: {
        type: String,
        default: 'is-10-mobile'
      },
      iconCssMobile: {
        type: String,
        default: 'is-2-mobile'
      },
      integerOnly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        keyword: '',
        has_keyword: false
      }
    },
    methods: {
      clearField () {
        this.has_keyword = false
        this.keyword = ''
      },
      resetForm () {
        if (this.has_keyword && this.keyword.length === 0) {
          this.has_keyword = false
          this.$emit('search', {})
        }
      },
      searchForm () {
        if (this.keyword.length > 0) {
          this.has_keyword = true
          this.$emit('search', this.keyword.trim())
        }
      },
      keywordChanged () {
        if (this.keyword.length > 0) {
          this.has_keyword = true
          this.$emit('keywordChanged', this.keyword)
        }
      },
      /**
       * Handle the input type for search box
       * @param $event
       * @return {boolean}
       */
      handleInput ($event) {
        if (this.integerOnly) {
          /* Only 0-9 digits allowed**/
          if ($event.keyCode < 48 || $event.keyCode > 57) {
            $event.preventDefault()
          }
          return true
        }
      }
    },
    created () {
      if (this.$route.query.keyword !== undefined) {
          this.keyword = this.$route.query.keyword
          this.has_keyword = true
          this.$emit('search', this.keyword)
      } else if (localStorage.hasOwnProperty('keywordFilter')) {
          this.keyword = localStorage.hasOwnProperty('keywordFilter')
          this.has_keyword = true
          this.$emit('search', this.keyword)
      } else {
          this.clearField()
      }
    }
  }
</script>

<style scoped>
    .input-search {
        border: 1px solid #8a8c91;
        border-right: 0;
        font-size: .85em !important;
        padding: 17px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue